import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetActiveVoucherDto, GetAdBlueListRequest, GetAdBlueListResponse, PostAdBlueFuelRequest } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'ad-blue-purchase.component.html',
  styleUrls: ['./ad-blue-purchase.component.scss']
})
export class AdBluePurchaseComponent implements OnInit {

  adBlueResponse: GetAdBlueListResponse | null = null;
  adBlueAmount: number = 0;
  adBlueReceiptNumber: string = '';
  popupVisibleError: boolean = false;
  errorMessage: string = '';
  loading: boolean = true;
  isPopupVisible = false;
  isMobile: boolean = false;
  voucher: GetActiveVoucherDto | null = null;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    
    if (this.router.url.endsWith('/service-ad-blue-purchase')) {
      this.voucher = this.activeUserLocalDataService.activeServiceVoucher;
    } else if (this.router.url.endsWith('/ad-blue-purchase')) {
      this.voucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    }
  
    if (!this.voucher) {
      const serviceVoucher = this.activeUserLocalDataService.activeServiceVoucher;
      const courierVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
      if (!serviceVoucher && !courierVoucher) {
        this.navigateToVoucher();
      } else {
        this.voucher = serviceVoucher || courierVoucher;
      }
    }
    this.loadAdBlueList();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  loadAdBlueList() {
    this.loading = true;
    let activeVoucher = this.voucher;
  
    if (!activeVoucher) {
      activeVoucher = this.activeUserLocalDataService.activeServiceVoucher || this.activeUserLocalDataService.getActiveCourierVoucher();
    }
  
    if (activeVoucher) {
      const request: GetAdBlueListRequest = { voucherId: activeVoucher.id };
      this.courierService.getAdBlueList(request).subscribe((response: GetAdBlueListResponse) => {
        this.adBlueResponse = response;
        this.loading = false;
      }, error => {
        console.error('Error fetching fuel list:', error);
        this.loading = false;
      });
    } else {
      console.error('Active voucher is null');
      this.router.navigate(['/voucher']);
      this.loading = false;
    }
  }

  navigateToVoucher() {
    const serviceVoucher = this.activeUserLocalDataService.activeServiceVoucher;
    const courierVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();
  
    if (serviceVoucher) {
      this.router.navigate(['/service-voucher']);
    } else if (courierVoucher) {
      this.router.navigate(['/voucher']);
    } else {
      this.router.navigate(['/voucher']);
    }
  }

  saveClick() {
    const errors: string[] = [];
  
    if (!this.adBlueAmount || this.adBlueAmount <= 0) {
      errors.push(this.translate.instant('InvalidAdBlueAmountPleaseEnterAValidAdBlueAmount'));
    }
  
    if (!this.adBlueReceiptNumber || this.adBlueReceiptNumber.startsWith('-')) {
      errors.push(this.translate.instant('InvalidReceiptNumberPleaseEnterAValidReceiptNumber'));
    }
  
    if (errors.length > 0) {
      this.errorMessage = errors.join('<br/><br/>');
      this.popupVisibleError = true;
      return;
    }
  
    const activeVoucher = this.activeUserLocalDataService.activeServiceVoucher || this.activeUserLocalDataService.getActiveCourierVoucher();
    if (!activeVoucher) {
      this.navigateToVoucher();
      return;
    }
  
    const request: PostAdBlueFuelRequest = {
      receiptNumber: this.adBlueReceiptNumber,
      vouchersId: activeVoucher.id,
      amount: this.adBlueAmount
    };
  
    this.courierService.postAdBlueFuel(request).subscribe(() => {
      this.navigateToVoucher();
    });
  }
}